// Shared file-library tag helpers (fixed set + custom tags).
export const FIXED_TAGS = ["Final art", "Proof", "Approved"];

const COLORS = {
  "Final art": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Proof": "bg-amber-100 text-amber-700 border-amber-200",
  "Approved": "bg-blue-100 text-blue-700 border-blue-200",
};

export const tagClasses = (t) => COLORS[t] || "bg-slate-100 text-slate-600 border-slate-200";
export const tagSlug = (t) => String(t).replace(/\s+/g, "-").toLowerCase();
